export default __webpack_public_path__ + "static/media/img-2.6681920b.jpg";